import Icon from "../../../controls/Icon";
import ProgressBar from "../../../controls/ProgressBar";
import { connect, PureComponentEx, translate, } from "../../../controls/ComponentEx";
import { bytesToString } from "../../../util/util";
import * as React from "react";
import { setAttributeFilter } from "../../../actions/tables";
const STATES = ["finalizing", "started", "paused"];
class SpeedOMeter extends PureComponentEx {
    render() {
        const { t, downloads, slim, speed } = this.props;
        const activeDownloads = Object.keys(downloads ?? {})
            .filter((id) => STATES.includes(downloads[id].state))
            .map((id) => downloads[id])
            .sort((lhs, rhs) => {
            if (lhs.state !== rhs.state) {
                return STATES.indexOf(lhs.state) - STATES.indexOf(rhs.state);
            }
            else {
                return lhs.startTime - rhs.startTime;
            }
        });
        if (activeDownloads.length === 0) {
            return null;
        }
        if (slim) {
            return (React.createElement("span", { className: "active-downloads-slim" },
                React.createElement(Icon, { name: "download-speed" }),
                " ",
                bytesToString(speed)));
        }
        else {
            return (React.createElement("div", { className: "active-downloads-container" },
                React.createElement("span", null, t("Active Downloads")),
                activeDownloads.slice(0, 2).map(this.renderDownload),
                activeDownloads.length > 2 ? (React.createElement("a", { onClick: this.openDownloads }, t("More..."))) : null,
                React.createElement("span", null,
                    React.createElement(Icon, { name: "download-speed" }),
                    " ",
                    bytesToString(speed),
                    "/s")));
        }
    }
    openDownloads = () => {
        this.context.api.events.emit("show-main-page", "Downloads");
        this.context.api.store.dispatch(setAttributeFilter("downloads", "progress", "In Progress"));
    };
    renderDownload = (download) => {
        const size = Math.max(1, download.size ?? 0, download.received);
        const perc = (download.received * 100) / size;
        return (React.createElement(ProgressBar, { key: download.localPath, min: 0, max: size, now: download.received, labelLeft: download.localPath, labelRight: perc.toFixed(0) + "%" }));
    };
}
function mapStateToProps(state) {
    return {
        downloads: state.persistent.downloads.files,
        speed: state.persistent.downloads.speed || 0,
    };
}
export default translate(["common"])(connect(mapStateToProps)(SpeedOMeter));
